/* eslint-disable */
import "./hot-controller"